// Polyfill for IE9+ and Safari
var supportDescriptors = require('core-js/internals/descriptors');
var defineProperty = require('core-js/internals/object-define-property').f;
var NAME = 'children';

// https://developer.mozilla.org/en-US/docs/Web/API/ParentNode/children#Polyfill_for_IE8_IE9_and_Safari
// Returns array instead of HTMLCollection.
if (supportDescriptors) {
  // Objects types that implement ParentNode interface
  var protos = [Document.prototype, DocumentFragment.prototype, SVGElement.prototype];
  for (var i = 0; i < protos.length; i++) {
    var proto = protos[i];

    if (proto.hasOwnProperty(NAME)) {
      continue;
    }

    defineProperty(proto, NAME, {
      configurable: true,
      get: function () {
        var i = 0, node, nodes = this.childNodes, children = [];
        while (node = nodes[i++]) {
          if (node.nodeType === 1) {
            children.push(node);
          }
        }
        return children;
      }
    });
  }
}
